/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Toast_Autosync_ErrorInputs */

const es_settings_dirs_toast_autosync_error = /** @type {(inputs: Settings_Dirs_Toast_Autosync_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la sincronización automática.`)
};

const en_settings_dirs_toast_autosync_error = /** @type {(inputs: Settings_Dirs_Toast_Autosync_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not update auto-sync.`)
};

/**
* | output |
* | --- |
* | "Could not update auto-sync." |
*
* @param {Settings_Dirs_Toast_Autosync_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_toast_autosync_error = /** @type {((inputs?: Settings_Dirs_Toast_Autosync_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Toast_Autosync_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_toast_autosync_error(inputs)
	return en_settings_dirs_toast_autosync_error(inputs)
});
export { settings_dirs_toast_autosync_error as "settings.dirs.toast.autosync_error" }